module.exports = __webpack_public_path__ + "img/harry-s.-truman.f018637c.png";